import { Omit } from '@material-ui/core';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import React, { ComponentType, PureComponent } from 'react';
import { CdnImage, CdnImageProps } from '../../../../../../../Cdn/CdnImage';

interface OwnProps extends Omit<CdnImageProps, 'cdnUrls' | 'classes'> {
  fallbackIcon: ComponentType<any>;
}

interface LogoProps extends OwnProps, WithStyles<typeof styles> {}

interface State {
  notFound: boolean;
}

class LogoBase extends PureComponent<LogoProps> {
  public state = {
    notFound: false,
  } as State;

  public render() {
    const { notFound } = this.state;
    const { alt, classes, fallbackIcon: FallbackIcon, ...props } = this.props;
    return (
      <>
        {notFound ? (
          <div className={classes.fallbackContainer} title={alt}>
            <FallbackIcon color="disabled" className={classes.fallback} />
          </div>
        ) : (
          <CdnImage onError={this.onError} alt={alt} title={alt} {...props} />
        )}
      </>
    );
  }

  protected onError = () => {
    this.setState({ notFound: true });
  };
}

const styles = createStyles({
  fallback: {
    height: '100%',
    width: '100%',
  },
  fallbackContainer: {
    display: 'inline-flex',
    overflow: 'hidden',
  },
});

/**
 * {name: 'ZuiImage'} tricks the ZUI Logos component into thinking it is an Image component.
 * This is so that it doesn't throw an error.
 */
export const Logo = withStyles(styles, { name: 'ZuiImage' })<OwnProps>(
  LogoBase,
);

Logo.displayName = 'Logo';
